// src/app/tokens/server-data.token.ts
import { InjectionToken } from '@angular/core';

export const SERVER_DATA = new InjectionToken<any>('SERVER_DATA');
